module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "formaAtendimento"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "color": "#ff4949"
    }
  }, [_vm._v("*")]), _vm._v(" Como será a forma de atendimento?")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.form.formaAtendimento),
      callback: function($$v) {
        _vm.$set(_vm.form, "formaAtendimento", $$v)
      },
      expression: "form.formaAtendimento"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Atendimento no Local"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Simples Escritório - Somente ponto de referência"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Online"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Outros"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tipoEmpresa"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "color": "#ff4949"
    }
  }, [_vm._v("*")]), _vm._v(" Tipo de Empresa")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.form.tipoEmpresa),
      callback: function($$v) {
        _vm.$set(_vm.form, "tipoEmpresa", $$v)
      },
      expression: "form.tipoEmpresa"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Sociedade (Limitada)"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Individual Limitada (Eireli)"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Associações (Condomínios, Igrejas, etc...)"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "outrasInformacoes"
    }
  }, [_c('h3', [_vm._v("Outras Informações")]), _vm._v(" "), _c('em', [_vm._v("Inserir informações que julgar necessário")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.outrasInformacoes),
      callback: function($$v) {
        _vm.$set(_vm.form, "outrasInformacoes", $$v)
      },
      expression: "form.outrasInformacoes"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39bccfef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConstituicaoDeEmpresa/Diversos.vue
// module id = 198
// module chunks = 1